/**
 * In-memory session store for fast synchronous access
 * Updated by AuthProvider's auth listener
 */

import type { Session } from "@supabase/supabase-js";

class SessionStore {
  private session: Session | null = null;

  setSession(session: Session | null) {
    this.session = session;
  }

  getSession(): Session | null {
    return this.session;
  }

  getAccessToken(): string | null {
    return this.session?.access_token ?? null;
  }
}

export const sessionStore = new SessionStore();
